//breaker component
const Breaker = ()  => {

    return(
        <div className="container breaker">
            <div className="row">
            <div className="divider-2"></div>
            </div>
        </div>
    );
}

export default Breaker;